!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a(require("dayjs")) : "function" == typeof define && define.amd ? define(["dayjs"], a) : e.dayjs_locale_pt = a(e.dayjs);
}(this, function (e) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e.default : e;
  var a = {
    name: "pt",
    weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),
    months: "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),
    ordinal: function ordinal(e) {
      return e + "º";
    },
    weekStart: 1,
    relativeTime: {
      future: "em %s",
      past: "há %s",
      s: "alguns segundos",
      m: "um minuto",
      mm: "%d minutos",
      h: "uma hora",
      hh: "%d horas",
      d: "um dia",
      dd: "%d dias",
      M: "um mês",
      MM: "%d meses",
      y: "um ano",
      yy: "%d anos"
    }
  };
  return e.locale(a, null, !0), a;
});